import gql from 'graphql-tag';

export class ConversationQueries {
  static loadList = gql`
    query Conversations {
      conversations {
        id
        type
        owner {
          participantId: recipientId
          userId
        }
        participants {
          participantId: recipientId
          userId
        }
      }
    }
  `;

  static loadDetailed = gql`
    query Conversation($conversationId: String!) {
      conversation(conversationId: $conversationId) {
        id
        participants {
          participantId: recipientId
          userId
        }
        title
        type
        messages {
          id
          createdAt
          updatedAt
          deletedAt
          text
          type
          owner {
            participantId: recipientId
            userId
          }
          reads {
            timestamp
            participant {
              participantId: recipientId
              userId
            }
          }
          metadata {
            editorComment {
              editorBlockId
              sectionId
              rowId
              cellId
              nodeId
            }
            videoId
            attachmentId
            imageId
            repliedTo
            mentions {
              participantId: recipientId
              userId
            }
          }
          isSystemMessage
        }
      }
    }
  `;
}
